import { type Dispatch, createContext, useContext } from 'react'
import { type Actions, type MobileState } from '@store/mobile-reducer.ts'

const MobileContext = createContext<{
	state: MobileState
	dispatch: Dispatch<Actions>
}>({
	state: {} as MobileState,
	dispatch: () => null,
})

const useMobileContext = () => useContext(MobileContext)

export { MobileContext, useMobileContext }
